<template>
  <div class="row justify-content-center">
    <!-- <div class="col-md-8"> -->
    <b-container class="col-md-8">
    <h3 class="text-center" style="margin-bottom: 30px;">Aggiorna CARD</h3>
    <b-row align-v="center" class="my-5">
      <b-col class="text-center">
        <label class="mx-3" style="font-size: x-large; margin: auto">UID</label><span  style="font-size: x-large; margin: auto"><strong>{{ cardUid }}</strong></span>
      </b-col>
      <b-col class="text-center">
        <b-dropdown variant="outline-primary" id="dropdown-form" text="Sostituisci CARD" ref="ddCard" class="ml-3 rounded-pill" style="width: 80%; float: left; " boundary="viewport">
          <b-dropdown-form>
            <b-form-group label="UID" label-for="dropdown-form-uid" @submit.stop.prevent>
              <b-form-input
                id="dropdown-form-uid"
                size="sm" 
                required 
                v-model="newCardUid"
                placeholder="uid"
              ></b-form-input>
              <b-form-checkbox
                id="checkbox"
                v-if="auth_user.claims.role=0"
                v-model="delFlag"
                name="checkbox"
                value="true"
                unchecked-value="false"
              ></b-form-checkbox>
            </b-form-group>
            <b-dropdown-divider></b-dropdown-divider>
            <b-button variant="outline-dark" size="sm" @click="$refs.ddCard.hide()">Annulla</b-button>
            <b-button pill variant="outline-primary" size="sm" @click="onCardSubstitute(cardUid, newCardUid)" style="float: right">SOSTITUISCI</b-button>
          </b-dropdown-form>
        </b-dropdown>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="text-center">
        <label class="mx-3" style="font-size: x-large; margin: auto">Full / Display Name</label>
        <span  style="font-size: x-large; margin: auto"><strong>{{ card.fullName }} / {{ card.displayName }}</strong></span>
      </b-col>
    </b-row>
    <b-row align-v="center" class="my-5">
      <b-col class="text-center">
        <label class="mx-3" style="font-size: x-large; margin: auto">Stato</label><span  style="font-size: x-large; margin: auto"><strong>{{ card.active? 'Attiva' : 'disattiva' }}</strong></span>
      </b-col>  
      <b-col class="text-center">
        <b-button pill variant="outline-primary" size="lg" @click="toggleActive()" class="ml-3 rounded-pill" style="width: 80%; float: left; ">Inverti STATO</b-button>
      </b-col>
    </b-row>
    <hr />
    <h4>Pacchetti attivi:</h4>
    <!-- SubsItems table element -->

    <b-table
      striped
      bordered
      outlined
      hover
      :head-variant="headVariant"
      :items="items"
      :fields="fields"
      :busy="isBusy"
      responsive="sm"
      table-class="w-auto" 
    >
      <template #table-busy>
        <div class="text-center text-light my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
      </template>
      <template #cell(washStatus)="row">
        <b-button size="sm" pill variant="outline-primary" title="modifica LAVAGGI -1" class="ml-1" style="" @click="editWashAct(row.item, row.index, -1, $event.target)">
          <span class="material-icons" style="vertical-align: middle; margin-right: 0;">arrow_downward</span>
        </b-button>
        <b-button size="sm" pill variant="outline-primary" title="modifica LAVAGGI +1" class="ml-1" style="primary" @click="editWashAct(row.item, row.index, 1, $event.target)">
          <span class="material-icons" style="vertical-align: middle; margin-right: 0;">arrow_upward</span>
        </b-button>
        {{ row.item.washAct }} di {{ row.item.washTot}}
      </template> 
      <template #cell(dueDate)="row">
        <b-input-group>
          <b-form-input
            id="duedate"
            v-model="row.item.dueDate"
            type="text"
            readonly
          ></b-form-input>
          <b-input-group-append>
            <b-form-datepicker
              v-model="row.item.editDueDate"
              button-only
              no-close-on-select
              right
              reset-button
              :reset-value="row.item.resetDueDate"
              label-reset-button="Reset"
              reset-button-variant="secondary"
              close-button
              label-close-button="Chiudi / Salva"
              close-button-variant="primary"
              :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
              locale="it"
              aria-controls="duedate"
              menu-class="datepicker-high-z"
              @hidden="changeDueDate(row.item, row.index, row.item.editDueDate)"
            >
            </b-form-datepicker>
          </b-input-group-append>
        </b-input-group>
      </template>
    </b-table>

    <template v-if="this.card.subsHistoryItems > 0">
      <h4>Pacchetti terminati/scaduti:</h4>
      <!-- HistItems table element -->

      <b-table
        striped
        bordered
        outlined
        hover
        :head-variant="headVariant"
        :items="histItems"
        :fields="histFields"
        responsive="sm"
        table-class="w-auto" 
      >
        <template #table-busy>
          <div class="text-center text-light my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
        <template #cell(washStatus)="row">
          {{ row.item.washAct }} di {{ row.item.washTot}}
        </template> 
      </b-table>
    </template>
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>

  </b-container>
</div>
</template>

<script>
  import { db } from '../../firebase/config.js';
  import { cardData } from '../../interfaces/CardData';
  import { mapGetters, mapMutations } from 'vuex';
  import axios from 'axios';

  export default {
    data() {
      return {
        cardUid: '',
        newCardUid: '',
        delFlag: 'true',
        //newDueDate: null,
        //rootRoute: 'http://localhost:5001/dogmoticswebapp/us-central1/webApi/api/v1/access/', //TEST mode
        rootRoute: 'https://us-central1-dogmoticswebapp.cloudfunctions.net/webApi/api/v1/access/', //LIVE mode
        card: cardData,
        modes: ['multi', 'single', 'range'],
        selectMode: 'multi',
        selected: [],
        row: {},
        selectAll: false,
        isBusy: true,
        headVariant: 'dark',
        items: [],
        histItems: [],
        userData: {},
        userDogs: [],
        userSubs: [],
        fields: [
          { key: 'dogName', label: 'CANE',  sortable: false,  },
          { key: 'breedName', label: 'Razza', sortable: false, },
          { key: 'subsName', label: 'Pacchetto SELF',  sortable: false,  },
          { key: 'washStatus', label: 'Lavaggi',  sortable: false,  },
          { key: 'dueDate', label: 'Scadenza',  sortable: false,  },
        ],
        histFields: [
          { key: 'dogName', label: 'CANE',  sortable: false,  },
          { key: 'breedName', label: 'Razza', sortable: false, },
          { key: 'subsName', label: 'Pacchetto SELF',  sortable: false,  },
          { key: 'washStatus', label: 'Lavaggi',  sortable: false,  },
          { key: 'dueDate', label: 'Scadenza',  sortable: false,  },
        ],
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, { value: 1000, text: "Tutte (1000)" }],
        sortBy: '',
        sortDesc: false,
        sortDirection: 'asc',
        filter: null,
        filterOn: [],
        infoModal: {
          id: 'info-modal',
          title: '',
          content: ''
        },
      }
    },
    created() {
      let docRef = db.collection('cards').doc(this.sel_card.uid);
      docRef.get().then((doc) => {
        this.card = doc.data();
        this.cardUid = doc.id;
        this.getItems();
      }).catch((error) => {
        console.log(error)
      })
    },
    methods: {
      getItems() {
        this.isBusy = true
        var i;
        this.items = []
        for (i = 0; i < this.card.subsItems; i++) {
          let X = i + 1 // adding new subsItemX to selected card
          let subsItemX = 'subsItem' + X.toString()
          this.items.push({
            dogName: this.card[subsItemX].DogName,
            breedName: this.card[subsItemX].DogBreed,
            subsName: this.card[subsItemX].SubsName,
            washAct: this.card[subsItemX].WashAct,
            washTot: this.card[subsItemX].WashTot,
            dueDate: this.card[subsItemX].DueDate,
            //editDueDate: property in format YYYY-MM-DD for datepicker editing form
            editDueDate: this.card[subsItemX].DueDate.substring(6,10) +
                        '-' + 
                        this.card[subsItemX].DueDate.substring(3,5) +
                        '-' +
                        this.card[subsItemX].DueDate.substring(0,2),
            resetDueDate: this.card[subsItemX].DueDate.substring(6,10) +
                        '-' + 
                        this.card[subsItemX].DueDate.substring(3,5) +
                        '-' +
                        this.card[subsItemX].DueDate.substring(0,2),
          })
        }
        console.log('items ->', this.items )
        this.isBusy = false
        
        //console.log('histLenght ->', this.card.subsHistoryItems.toString())

        if(this.card.subsHistoryItems > 0) {
          this.histItems = []
          for (i = this.card.subsHistoryItems; i > 0; i--) {
            this.histItems.push({
              dogName: this.card.subsHistory[i-1].DogName,
              breedName: this.card.subsHistory[i-1].DogBreed,
              subsName: this.card.subsHistory[i-1].SubsName,
              washAct: this.card.subsHistory[i-1].WashAct,
              washTot: this.card.subsHistory[i-1].WashTot,
              dueDate: this.card.subsHistory[i-1].DueDate,
            })
          }
          console.log('histItems ->', this.histItems  )
        }
      },
      info(title, message) {
        this.infoModal.title = title
        this.infoModal.content = message
        this.$root.$emit('bv::show::modal', this.infoModal.id)
      },
      resetInfoModal() {
        this.infoModal.title = ''
        this.infoModal.content = ''
        //this.$router.push({name:'list_cards'})
      },
      toggleActive() {
        event.preventDefault()
        //complete route URL with parameters
        let route = this.rootRoute
        route = route + this.auth_user.data.storeId + '/' //added storeId parameter
        route = route + 'AA01' + '/' //added device code = Admin App
        route = route + 'ev43' + '/' //added event code = toggle card status
        route = route + this.sel_card.uid + '/' //added card UID
        route = route + '0'

        axios.get(route, {
          headers: {
            Authorization: 'Bearer {1gO7et4Nx7SIMGkf51ZK8kTUqnAQj1j7y39geoAc}'
          }
        })
        .then(response => {
          if(response.status === 200) {
            console.log('Card Status toggled', response.status, response.data)
            this.card.active = !this.card.active
            const cardStatus = this.card.active? 'Attiva' : 'Disattiva'
            this.info('Aggiornamento OK', 'STATO Card modificato: ' + cardStatus );
          }
          else {
            console.log('Event Error', response.status, response.data)
            this.info('ERRORE', 'Aggiornamento KO');
          }
        })
        .catch((err) => {
          //Display error
          console.log(err.message, err)
          this.info('Errore!', err.message);
        })    
      },
      editWashAct(item, index, minusPlusOne) {
        event.preventDefault()
        console.log('index: ', index)
        let cardSubsItem = (index + 1).toString()
        //complete route URL with parameters
        let route = this.rootRoute
        route = route + this.auth_user.data.storeId + '/' //added storeId parameter
        route = route + 'AA01' + '/' //added device code = Admin App
        if(minusPlusOne == 1) {
          route = route + 'ev41' + '/' //added event code = inc +1 Actual Washes
        }
        if(minusPlusOne == -1) {
          route = route + 'ev42' + '/' //added event code = dec -1 Actual Washes
        }
        route = route + this.sel_card.uid + '/' //added card UID
        route = route + cardSubsItem

        axios.get(route, {
          headers: {
            Authorization: 'Bearer {1gO7et4Nx7SIMGkf51ZK8kTUqnAQj1j7y39geoAc}'
          }
        })
        .then(response => {
          if(response.status === 200) {
            console.log('Event created', response.status, response.data)
            item.washAct = item.washAct + minusPlusOne
            this.info('Aggiornamento OK', 'LAVAGGI effettuati: ' + minusPlusOne.toString());
          }
          else {
            console.log('Event Error', response.status, response.data)
            this.info('ERRORE', 'Aggiornamento KO');
          }
        })
        .catch((err) => {
          //Display error
          console.log(err.message, err)
          this.info('Errore!', err.message);
        })    
      },
      onCardSubstitute(oldCardId, newCardId) {
        if(!newCardId)
        {
           alert('Inserire Card UID')
           return
        }
        db.collection('cards')
        .doc(newCardId)
        .set(this.card)
        .then(() => {
          //Test new card existence and then delete old card
          db.collection('cards')
          .doc(newCardId).get()
          .then((doc) => {
            //Display success
            this.info('Registrazione OK', `Creata nuova CARD ${doc.id}`);
            console.log('oldCardUid ->', oldCardId)
            console.log('delFlag ->', this.delFlag)
            if(this.delFlag=='true') {
              this.deleteCard(oldCardId)
            }
            this.createNewUidEvent(doc.id)
          });
        })
        .catch((err) => {
           //Display error
           console.log(err.message, err)
           this.info('Errore!', err.message);
        });
        this.$refs.ddCard.hide()
      },
      deleteCard(id){
      //if (window.confirm(`Vuoi cancellare la CARD ${id}?`)) {
        db.collection("cards").doc(id).delete()
        .then(() => {
          this.info(`CARD ${id} cancellata!`);
        })
        .catch((error) => {
          console.error(error);
        })
      //}
      },
      createNewUidEvent(newCardId){
        //complete route URL with parameters
        let route = this.rootRoute
        route = route + this.auth_user.data.storeId + '/' //added storeId parameter
        route = route + 'AA01' + '/' //added device code = Admin App
        route = route + 'ev45' + '/' //added event code = toggle card status
        route = route + newCardId + '/' //added new card UID
        route = route + '0'

        axios.get(route, {
          headers: {
            Authorization: 'Bearer {1gO7et4Nx7SIMGkf51ZK8kTUqnAQj1j7y39geoAc}'
          }
        })
        .then(response => {
          if(response.status === 200) {
            console.log('Card UID substituted', response.status, response.data)
            this.cardUid = newCardId
            this.info('Aggiornamento OK', 'Card UID sostituita: ' + newCardId );
          }
          else {
            console.log('Event Error', response.status, response.data)
            this.info('ERRORE', 'Aggiornamento KO');
          }
        })
        .catch((err) => {
          //Display error
          console.log(err.message, err)
          this.info('Errore!', err.message);
        }) 
      },
      changeDueDate(item, index, editDueDate) {

        this.isBusy = true
        console.log('dueDate prima/dopo', item.resetDueDate, editDueDate)
        if(item.resetDueDate == editDueDate) {
          this.isBusy = false
          this.info('SCADENZA originale lasciata inalterata');
          return
        }

        const formatDueDate = editDueDate.substring(8,10) + '/' +
                              editDueDate.substring(5,7) + '/' + 
                              editDueDate.substring(0,4) //reformat due date in order to pass it as parameter (string date with '/' separator substituted with '.')
        const subsItemNr = (index + 1).toString()

        //complete route URL with parameters
        let route = this.rootRoute
        route = route + this.auth_user.data.storeId + '/' //added storeId parameter
        route = route + 'AA01' + '/' //added device code = Admin App
        route = route + 'ev44' + '/' //added event code = toggle card status
        route = route + this.sel_card.uid + '/' //added card UID
        route = route + subsItemNr + '/0/0/0/' //added card SubsItemNr + first 3 optional parameters (=0)
        route = route + formatDueDate.replaceAll("/", ".") //added subsItem DueDate as 4th optional parameter

        axios.get(route, {
          headers: {
            Authorization: 'Bearer {1gO7et4Nx7SIMGkf51ZK8kTUqnAQj1j7y39geoAc}'
          }
        })
        .then(response => {
          this.isBusy = false
          if(response.status === 200) {
            console.log('SubsItem DueDate updated', response.status, response.data)
            item.dueDate = formatDueDate
            this.info('Aggiornamento OK', 'SCADENZA aggiornata: ' + formatDueDate );
          }
          else {
            console.log('Event Error', response.status, response.data)
            this.info('ERRORE', 'Aggiornamento KO');
          }
        })
        .catch((err) => {
          //Display error
          console.log(err.message, err)
          this.info('Errore!', err.message);
        }) 
      },
      ...mapMutations({
        set_sel_dog: 'SET_SEL_DOG', // map `this.set_sel_dog()` to `this.$store.commit('SET_SEL_DOG')`
        set_sel_card: 'SET_SEL_CARD'
      }),
    },
    computed: {
      ...mapGetters({
        // map `this.sel_user` to `this.$store.getters._user`
        auth_user: "user",
        sel_user: "_user",
        sel_dog: "_dog",
        sel_card: "_card"
      }),
      newDueDate: {
        // getter
        get: function () {
          const formatDate = {
            YYYY: this.row.item.dueDate.substring(5,4),
            MM: this.row.item.dueDate.substring(2,2),
            DD: this.row.item.dueDate.substring(0,2)
          }
          return formatDate.YYYY + '-' + formatDate.MM + '-' + formatDate.DD
        },
        /*// setter
        set: function (newValue) {
          var names = newValue.split(' ')
          this.firstName = names[0]
          this.lastName = names[names.length - 1]
        }*/
      },
    },
  };
</script>
<style>
  /* Fix z-index datepicker per mobile portrait */
  .datepicker-high-z,
  .b-form-datepicker .dropdown-menu,
  .b-calendar-grid {
    z-index: 9999 !important;
  }

  /* Assicura che il calendario sia sopra tutto in portrait */
  @media (max-width: 576px) and (orientation: portrait) {
    .b-form-datepicker .dropdown-menu {
      z-index: 9999 !important;
      max-height: 70vh;
      overflow-y: auto;
    }
  }
</style>